// This needs to be attached directly to a form to work.
var VOLATILE_FIELDS = ['authenticity_token', 'utf8', '_method'];
var SIGNATURE_KEY = 'dirtyFormSignature';

function formSignature(form) {
  return $(form)
    .serializeArray()
    .filter(function (field) {
      return VOLATILE_FIELDS.indexOf(field.name) === -1;
    })
    .map(function (field) {
      return field.name + '=' + field.value;
    })
    .join('&');
}

function dirtyForms() {
  return $('.js-dirty-form-alert').filter(function () {
    var signature = $(this).data(SIGNATURE_KEY);

    return signature !== undefined && signature !== formSignature(this);
  });
}

onmount(".js-dirty-form-alert", function () {
  $(this).data(SIGNATURE_KEY, formSignature(this));
});

var skipDirtyFormCheck = false;

window.dirtyFormCheck = function (event) {
  if (skipDirtyFormCheck || !dirtyForms().length) {
    return;
  }

  var url = event && event.data && event.data.url;

  if (!url) {
    return;
  }

  var domId = "continue-after-dirty-form-" + new Date().getTime();

  $('<a>', { href: url, id: domId, class: 'd-none' })
    .on('click', function () { skipDirtyFormCheck = true; })
    .appendTo('body');

  Rails.confirm("<h4>Leave page with unsaved changes?<br /><small>Leaving this page will delete all unsaved changes.</small></h4>", '#' + domId)

  event.preventDefault();
}

$(document).on('turbolinks:before-visit', function(event){
  if(window.dirtyFormCheck != undefined) {
    window.dirtyFormCheck(event.originalEvent || event);
  }
});

$(document).on("turbolinks:before-cache", () => {
  skipDirtyFormCheck = false;
  $("a[id^='continue-after-dirty-form-']").remove();
});

onmount();
